export default "__VITE_ASSET__owECvydC__"